var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSamplesSpatial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 9H11V11H13C13.5304 11 14.039 11.2109 14.4141 11.5859C14.7891 11.961 15 12.4696 15 13V15C15 15.5304 14.7891 16.039 14.4141 16.4141C14.039 16.7891 13.5304 17 13 17H11C10.4696 17 9.96101 16.7891 9.58594 16.4141C9.21087 16.039 9 15.5304 9 15C9 14.4477 9.44772 14 10 14C10.5523 14 11 14.4477 11 15H13V13H11C10.4696 13 9.96101 12.7891 9.58594 12.4141C9.21087 12.039 9 11.5304 9 11V9C9 8.46957 9.21087 7.96101 9.58594 7.58594C9.96101 7.21087 10.4696 7 11 7H13C13.5304 7 14.039 7.21087 14.4141 7.58594C14.7891 7.96101 15 8.46957 15 9C15 9.55228 14.5523 10 14 10C13.4477 10 13 9.55228 13 9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20V22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22V20C16.4183 20 20 16.4183 20 12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamplesSpatial);
export default __webpack_public_path__ + "static/media/samples-spatial.fa7737b4dbe9f77f0d2c25a2803bb43f.svg";
export { ForwardRef as ReactComponent };